import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    day: 'day',
    days: 'days',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    lessThanOneMinute: 'Less than a minute',
    withdrawalCancelledTitle: 'Withdrawal cancelled',
    withdrawalCancelledBody: 'Your withdrawal cancellation was successful.',
    depositAgain: 'Deposit again',
  },
};
